import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/apologetics', label: 'Apologetics' },
    { path: '/free-grace', label: 'Free Grace' },
    { path: '/debates', label: 'Debates' },
    { path: '/articles', label: 'Articles' },
    { path: '/media', label: 'Media' },
    { path: '/resources', label: 'Resources' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="dark-header">
      <Link to="/" className="logo-link">
        <img src="/praise-iam-logo.png" alt="Praise I AM Apologetics" className="logo-image" />
      </Link>

      {/* Desktop Navigation */}
      <nav className="dark-nav desktop-nav">
        {navLinks.slice(1, 6).map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`dark-nav-link ${isActive(link.path) ? 'active' : ''}`}
          >
            {link.label}
          </Link>
        ))}
      </nav><a
  href="https://paypal.me/PraiseIAM"
  target="_blank"
  rel="noopener noreferrer"
  className="donate-btn"
>
  Donate
</a>

      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-btn"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
